import { themeObject, validationsMessages } from 'lib';
import * as yup from 'yup';

export const addStepModalStyles = {
    dialogStyles: {
        '& .MuiPaper-root': {
            width: '690px',
            maxWidth: '690px',
            '#dialog-title-container': {
                minHeight: '60px',
            },
            '& .MuiDialogContent-root': {
                p: '0px 50px 35px 50px',
                overflow: 'hidden',
            },
        },
    },
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    fieldGroup: {
        display: 'flex',
        flexDirection: 'column',
        mt: 2,
        width: '100%',
        gap: '4px',
    },
    stepsSelect: {
        width: '100%',
        '& .MuiSelect-icon': {
            color: themeObject.palette.primary.dark,
        },
        '& .MuiFormControl-root': {
            width: '100%',
            '& .MuiTextField-root': {
                '& .MuiInputBase-root': {
                    minHeight: '40px',
                    pr: '50px',
                    '& .MuiInputBase-input': {
                        height: '100%',
                    },
                },
            },
        },
    },
    stepsLabelStyles: {
        mt: 0.5,
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        mt: 3.25,
        gap: 1,
    },
    addStepButton: {
        boxShadow: 'none',
    },
    typeOptionsList: {
        borderRadius: '15px',
    },
    stepOptionListConatiner: {
        maxHeight: '260px',
        overflowY: 'auto',
    },
    stepOptionList: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '4px',
    },
    optionDescriptionConatiner: {
        display: 'flex',
        alignItems: 'baseline',
        gap: 0.5,
    },
    descriptionHeadingStyles: {
        fontWeight: '600',
        fontSize: '12px',
        letterSpacing: '0.4px',
    },
    menuItemDescriptionStyles: {
        gap: 0.5,
        '& .MuiTypography-root': {
            fontSize: '12px',
        },
    },
    noOptionStateStyles: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        textAlign: 'center',
        p: '62.5px 0',
    },
    noOptionStateHeading: {
        ...themeObject.typography.h3,
        color: themeObject.palette.primary[700],
    },
};

export interface StepData {
    author: string;
    description: string;
    funcName: string;
    hash: string;
    id: string;
    jsBase64: string;
    name: string;
    timestamp: string;
    type: string;
}

export interface AddStepFormData {
    type: string;
    step: StepData | null;
}

export const AddStepSchema = yup.object({
    type: yup.string().required(validationsMessages.required),
    step: yup.object().nullable().required(validationsMessages.required),
});

export const AddStepDefaults: AddStepFormData = {
    type: '',
    step: null,
};
